module.exports = __webpack_public_path__ + "img/vision_2.1b4831df.png";